import { TotalStudyStatusPageQuery } from '@asset/type/study-status';
import { StudentGroupType } from '@components/common/dropDown/SelectStudentDropDown';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FilteringObjQuery {
  urlQueryObj: any;
  setUrlQueryObj: (obj) => void;
}

interface GnbStudentListFilteringInfo {
  [teacherId: number]: StudentGroupType;
}

interface GnbStudentListFilteringQuery {
  filteringInfo: GnbStudentListFilteringInfo;
  setFilteringInfo: (obj: GnbStudentListFilteringInfo) => void;
}

interface AttendanceFilteringObjQuery {
  todayUrlQueryObj: object;
  setTodayUrlQueryObj: (obj) => void;
  totalUrlQueryObj: object;
  setTotalUrlQueryObj: (obj) => void;
}

export const useStatusFilteringQueryStore = create<{
  totalUrlQueryObj: TotalStudyStatusPageQuery;
  setTotalUrlQueryObj: (obj: TotalStudyStatusPageQuery) => void;
}>((set) => ({
  totalUrlQueryObj: null,
  setTotalUrlQueryObj: (obj: TotalStudyStatusPageQuery) =>
    set({ totalUrlQueryObj: obj }),
}));

export const useAttendanceFilteringQueryStore =
  create<AttendanceFilteringObjQuery>((set) => ({
    todayUrlQueryObj: null,
    setTodayUrlQueryObj: (obj: object) => set({ todayUrlQueryObj: obj }),
    totalUrlQueryObj: null,
    setTotalUrlQueryObj: (obj: object) => set({ totalUrlQueryObj: obj }),
  }));

export const useStudentListFilteringQueryStore = create<FilteringObjQuery>(
  (set) => ({
    urlQueryObj: null,
    setUrlQueryObj: (obj: object) => set({ urlQueryObj: obj }),
  }),
);

export const useGnbStudentListFilteringQueryStore = create(
  persist<GnbStudentListFilteringQuery>(
    (set) => ({
      filteringInfo: null,
      setFilteringInfo: (_filteringInfo: GnbStudentListFilteringInfo) => {
        set((state) => {
          return {
            filteringInfo: {
              ...state.filteringInfo,
              ..._filteringInfo,
            },
          };
        });
      },
    }),
    {
      name: 'gnb-student-list-filtering-storage',
    },
  ),
);
